import React, { useState, useEffect } from "react";
import {
  Grid,
  Container,
  Typography,
  Box,
  Button,
  useTheme,
} from "@mui/material";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import BASE_URL from "../../config/apiConfig";
import PlantationCard from "../PricingCards/PlantationCard";
import FieldCropCard from "../PricingCards/FieldCropCard";
import PlanComparisonTable from "../Pricing/PlanComparisonTable";
import TrialFeatureSection from "./TrialFeatureSection";
import PricingCalculator from "./PricingCalculator";

export default function PricingPage() {
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const [cookies] = useCookies(["user_auth_token"]);
  const navigate = useNavigate();
  const theme = useTheme();

  useEffect(() => {
    if (cookies.user_auth_token) {
      fetchUserDetails(cookies.user_auth_token);
    }
  }, [cookies.user_auth_token]);

  const fetchUserDetails = async (token) => {
    try {
      const response = await fetch(`${BASE_URL}/api/auth/user-details`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setUserDetails(data);
      } else {
        console.error("Failed to fetch user details");
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };

  // const handleChoosePlan = (planDetails) => {
  //   setSelectedPlan(planDetails);
  //   if (cookies.user_auth_token) {
  //     navigate("/payment", { state: { selectedPlan: planDetails } });
  //   } else {
  //     navigate("/user/login", {
  //       state: { redirectTo: "/payment", selectedPlan: planDetails },
  //     });
  //   }
  // };

  // const handleBack = () => {
  //   setSelectedPlan(null);
  // };

  return (
    <>
      {/* Hero Banner */}
      <div
        style={{
          width: "100%",
          height: "50vh",
          background:
            'url("/Images/Pricing_Background.webp") center/cover no-repeat',
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          boxShadow: "inset 0 0 0 1000px rgba(0, 0, 0, 0.3)",
          textAlign: "center",
        }}
      >
        <Typography variant="h2" fontWeight="bold">
          Subscription Plans 🌿
        </Typography>
        <Typography variant="subtitle2" sx={{ mt: 1 }}>
          Choose a plan that grows with your farm
        </Typography>
      </div>

      {/* Trial Section */}
      <Container maxWidth="lg" sx={{ py: { xs: 4, sm: 8 } }}>
        <TrialFeatureSection />
        <Typography
          variant="subtitle2"
          color="text.secondary"
          sx={{
            mt: 2,
            mb: 4,
            fontStyle: "italic",
            textAlign: "center",
          }}
        >
          Try features tailored for real farmers — commitment-free 🌱
        </Typography>
      </Container>

      {/* Pricing Calculator */}
      <Box
        sx={{
          py: { xs: 4, sm: 8 },
          bgcolor: theme.palette.grey[100],
          textAlign: "center",
        }}
      >
        <Typography variant="h4" fontWeight="bold" color="#2E7D32" gutterBottom>
          💡 Plan Smarter with Our Crop Cost Estimator
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mb: 4, fontStyle: "italic" }}
        >
          Prices shown are estimates to help you plan your farming budget
          better.
        </Typography>
        <PricingCalculator />
        <Button
          variant="contained"
          color="success"
          size="medium"
          sx={{ mt: 3, borderRadius: 4 }}
          onClick={() => {
            if (cookies.user_auth_token) {
              navigate("/user/add-farm-now");
            } else {
              navigate("/user/login", {
                state: { redirectTo: "/user/add-farm-now" },
              });
            }
          }}
        >
          Start Adding Farm Now 🌾
        </Button>
      </Box>

      {/* Plan Comparison */}
      <Box sx={{ py: { xs: 4, sm: 8 } }}>
        <PlanComparisonTable />
        <Box sx={{ textAlign: "center", mt: 4 }}>
          <Typography variant="h6" color="#2E7D32" sx={{ fontWeight: 600 }}>
            Confused? Compare Before You Commit 🤔
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Match features side-by-side and choose what's best for your land.
          </Typography>
          <Button
            variant="outlined"
            size="medium"
            color="#2E7D32"
            sx={{ borderRadius: 4 }}
            onClick={() => navigate("/user/farm-setup")}
          >
            Start Your Farm Setup 🚀
          </Button>
        </Box>
      </Box>
    </>
  );
}
